export const alertConst = {
  SUCCESS: 'ALERT_SUCCESS',
  INFO: 'ALERT_INFO',
  WARN: 'ALERT_WARN',
  ERROR: 'ALERT_ERROR',
  CLOSE: 'ALERT_CLOSE'
}